import moment from "moment";
import { Appointment } from "types/request";

export function appointmentTime(appointment: Appointment): string {
    return {
        AM: '8am - 12pm',
        PM: '12pm - 5pm',
        AT: '8am - 5pm',
    }[appointment.timeWindow]
    ?? `${moment.parseZone(appointment.start).format('ha')} - ${moment.parseZone(appointment.end).format('ha')}`;
}
